import React, { useRef, useEffect } from "react";
import "./Download.scss";
import SiteButton from "../../ui/SiteButton";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useLang } from "../../../i18n/LangContext";

const DownloadBox = ({ title, description, installerUrl, rarUrl }) => {
  const { t } = useLang();
  const scrollTargetRef = useRef(null);

  useEffect(() => {
    const yOffset = -80;
    const y =
      scrollTargetRef.current.getBoundingClientRect().top +
      window.pageYOffset +
      yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  }, []);

  return (
    <div className="page-wrapper">
      <div ref={scrollTargetRef} className="download-container">
        <CloudDownloadIcon className="download-icon" />

        <h2>{title || t("download_title")}</h2>
        <p>{description || t("download_description")}</p>

        <div className="download-buttons">
          <SiteButton
            variant="secondary"
            onClick={() =>
              window.open(installerUrl, "_blank", "noopener,noreferrer")
            }
          >
            DOWNLOAD INSTALLER
          </SiteButton>

          <SiteButton
            variant="secondary"
            onClick={() => window.open(rarUrl, "_blank", "noopener,noreferrer")}
          >
            DOWNLOAD RAR
          </SiteButton>
        </div>
      </div>
    </div>
  );
};

export default DownloadBox;
